<template>
  <v-container grid-list-md text-xs-center>
    <v-layout align-center justify-center row fill-height>
        <v-flex xs6 sm6 md6>
            <v-card>
               <v-img src="https://repository.mundoinspira.com/payment/IconosPago/MexicoPay/oxxo_logo.jpg" aspect-ratio="1.7"></v-img>
            </v-card> 
             <v-card align-center>
                <span v-html="$t('message.expired_msg', { valueExpire: valueExpire })"></span>
            </v-card>
       </v-flex>
    </v-layout>   
    <v-layout align-center justify-center row fill-height>
            <v-flex xs12 sm12 md12>  
               <v-btn :href="value" 
                :loading="loading3" :disabled="loading3" color="success" class="white--text" @click="generarRecibo"
                >
                Generar Comprobate
                    <v-icon right dark>check_circle</v-icon>
                </v-btn>
            </v-flex>
              
    </v-layout>  
  </v-container>
</template>

<script>
import { EventBus } from "./EventBus.js";

export default {
    data () {
      return {
        loader: null,
        loading3: false,
        value: "",
      }
    },
    props: ['valueExpire'],
    mounted() {
      this.$nextTick(function() {
        //EventBus.$on("URL_PAYMENT_RECEIPT_PDF", this.setUrlRECEIPT);
        //EventBus.$on('callerData', this.setBuyerData2);
      });
    },
    methods: {
      setUrlRECEIPT(value) {
        this.value = value;
         EventBus.$emit("nextStep");
      },
      generarRecibo() {
        console.log("generarRecibo >>>>>>>>>>>>>>");
        EventBus.$emit('generarRecibo',{
          method:"OXXO",
          provider:"payu",
          expire:this.valueExpire
          });
      },

    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      }
    }
  
}
</script>


<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>


